import AContainer from "../../library/ExtendedObjects/AContainer.js";
import gameData from "../../gameData.js";

export default class Game_ProgressBar extends AContainer
{
    constructor(scene, x, y)
    {
        super(scene, x, y);
        this.scene.add.existing(this);

        this.alpha = 0;

        this.background = this.create(0, 0, "PrgBar_Bk");
        this.foreground = this.create(0, 15, "PrgBar_Frnt");

        this.lastCoin = null;

        for(let i = 0; i < gameData.curProgress; i++)
        {
            let progCoin = this.create(1, -200, "PrgBar_Coin");
            progCoin.y = (this.lastCoin == null ? 124 : this.lastCoin.y - 56);
            this.lastCoin = progCoin;
            this.sendToBack(progCoin);
            this.sendToBack(this.background);
        }
    }

    incrementProgress(animate = true)
    {
        let progCoin = this.create(1, -200, "PrgBar_Coin");

        if(animate) 
        {
            this.scene.addTween(progCoin, 1200, {y: (this.lastCoin == null ? 124 : this.lastCoin.y - 56)}, "Bounce");
            this.scene.playSound("gain_coin");
        }
        else progCoin.y = (this.lastCoin == null ? 124 : this.lastCoin.y - 56);
        this.lastCoin = progCoin;

        gameData.curProgress++;

        this.sendToBack(progCoin);
        this.sendToBack(this.background);
    }
}